class ItemPlannerBroadcast {

    constructor($scope, $rootScope, $state) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
    }

    createItemInBlock(block) {
        this.$state.go('item-planner.item-create', {
            blockId: block.id,
            createInDate: moment(block.start).format('YYYY-MM-DD'),
        });
    }

    openBroadcastBlocks(broadcastId = this.$scope.broadcast.id) {
        this.$rootScope.$broadcast('item-planner_show-broadcast', broadcastId);
    }

    onMouseOver() {
        if (this.$rootScope.itemPlannerInCopyState) {
            this.openBroadcastBlocks();
        }
    }

}

export default [() => {
    return {
        templateUrl: '/partial/app.partials.item-planner.directives.broadcast',
        replace: true,
        controller: [
            '$scope',
            '$rootScope',
            '$state',
            ItemPlannerBroadcast,
        ],
        controllerAs: 'ctrl',
        scope: {
            broadcast: '=',
        },
    };
}];
